<block-ui [delayStart]="100" [delayStop]="200">
  <section class="main-body">
    <p [hidden]="true"> Version: {{version}}</p>
    <app-header *ngIf="showHeader"></app-header>
    <div class="modal fade" id="sessiontimeout" [ngClass]="{'show' : IsSessionExpired, 'hide':!(IsSessionExpired)}"
         [ngStyle]="{'display': IsSessionExpired ? 'block' : 'none'}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title w-100 d-block">
              Session Timeout !
              <a (click)="closeTimeoutPopup();" class="fs-12 text-underline float-right pt-1 text-white" data-dismiss="modal"><i class="fas fa-times"></i></a>
            </h5>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <p class="fs-14 text-center">
                    Your session has expired due to inactivity. Please click here to <a href="javascript:void(0)"
                                                                                        (click)="openLoginForm()">Login</a>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <section class="pageContentMain">

      <router-outlet></router-outlet>
      <app-footer *ngIf="showFooter"></app-footer>

      <!-- Auto Modal Popover -->
      <div *ngIf="showHeader && !regLogin" class="modal self-hcp-backdrop fade" [ngClass]="{'show' : !authService.isUserLoggedIn() && (!utilityService.isProfileSelected() || utilityService.isProfileSelection) }" id="autoModal" data-backdrop="true" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
           [ngStyle]="{'display': !authService.isUserLoggedIn() && (!utilityService.isProfileSelected() || utilityService.isProfileSelection) ? 'block' : 'none'}">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Welcome to {{utilityService.getPortalName()}} Information</h5>
            </div>
            <div class="modal-body popup-scroll">
              <p class="fs-13 text-center">
                This website is intended only for US Healthcare Professionals. The information provided is for your personal and general education purpose only. The information provided is not intended to offer an opinion or provide medical advice.
              </p>
              <p class="fs-13 text-center pt-2"> Are you a healthcare professional practicing in the United States? </p>

              <ng-container *ngFor="let userprofile of portalProfiles">
                <button type="button" class="btn btn-block btn-primary mt-3 fs-14" data-dismiss="modal" (click)="NavigatePortalUser(userprofile, true);">{{userprofile.NAME}}</button>
              </ng-container>
              <p class="fs-13 pt-3">Please contact us at <a href="">1-888-GLU-VIVA</a> to report an adverse event or product complaint or to speak to Medical Information Specialist.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Non HCP redirection popup -->
      <div *ngIf="showHeader" class="modal self-hcp-backdrop fade" [ngClass]="{'show': utilityService.isNonHCP}" id="nonhcpredirection" data-backdrop="false" tabindex="-1" role="dialog"
           [ngStyle]="{'display': utilityService.isNonHCP ? 'block' : 'none'}" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title w-100 d-block">
                Thanks for Visiting {{utilityService.getPortalName()}}
              </h5>
            </div>
            <div class="modal-body pt-0">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12 text-center mt-3 px-0">
                    <h3 class="fs-14">
                      You are now leaving GluvivaMedial.com website. If you do not wish to be redirected, please click on the Go Back button.
                    </h3>
                    <p class="fs-14 pt-3">Please Click<a href="https://www.eversana.com/"> Here </a> to Continue to Eversana</p>
                    <!-- <p class="fs-14 pt-3">Please <a href="https://www.scimaxglobal.com/">Click Here </a> to Continue to page 1</p>
                    <p class="fs-14 pt-3">Please <a href="https://www.techsolcorp.com/">Click Here </a> to Continue to page 2</p> -->
                  </div>
                  <button type="button" class="btn btn-primary btn-block text-center mt-3 fs-14" data-dismiss="modal" (click)="onBack();">Back</button>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div *ngIf="utilityService.IsNotHcpAction" class="modal self-hcp-backdrop fade show z-index-3" id="nonhcpredirection2"
           [ngStyle]="{'display': utilityService.IsNotHcpAction ? 'block' : 'none'}"
           data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title w-100 d-block">
                Thanks for Visiting {{utilityService.getPortalName()}}
              </h5>
            </div>
            <div class="modal-body pt-0">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12 text-center mt-3 px-0">
                    <h3 class="fs-14">
                      You are now leaving GluvivaMedial.com website. If you do not wish to be redirected, please click on the Go Back button.
                      <!-- You are about to leave {{utilityService.getPortalName()}} Medical
                      <P>Information Portal</P> -->
                    </h3>
                    <p class="fs-14 pt-3">Please Click<a href="https://www.eversana.com/"> Here </a> to Continue to Eversana</p>
                    <!-- <p class="fs-14 pt-3">Please <a href="https://www.scimaxglobal.com/">Click Here </a> to Continue to page 1</p>
                    <p class="fs-14 pt-3">Please <a href="https://www.techsolcorp.com/">Click Here </a> to Continue to page 2</p> -->
                  </div>
                  <button type="button" class="btn btn-primary btn-block text-center mt-3 fs-14" data-dismiss="modal" (click)="onNonHCPClose();">Close</button>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div *ngIf="showHeader" class="privacyPrompt pt-4" [ngStyle]="{'display':cookieToogle ? 'block' : 'none'}">
        <div class="row">
          <div class="col-md-7 col-sm-7">
            <p>
              This website uses cookies. By using our website without changing your cookie settings you agree to our use of cookies as described in our <a href="https://www.scimaxglobal.com/privacy-policy/" target="_blank">Privacy Policy.</a>
            </p>
          </div>
          <div class="col-md-5 col-sm-5">
            <div class="text-right mbl-100 cookieSettings">
              <a href="javascript:void(0);" (click)="allowCookies()">Accept</a>
              <a href="javascript:void(0)" (click)="closeCookies()">Reject</a>
            </div>
          </div>
        </div>

      </div>

    </section>

    <app-toast-message></app-toast-message>
  </section>
</block-ui>
